import { pickAll } from 'ramda';
import React from 'react';

import { connect } from 'react-redux';

import type { UserSelectorState } from '@peloton/auth';
import { trackVideo, VideoEvent } from '@ecomm/analytics';
import { getUserTrackingProperties } from '@ecomm/auth';

import type { VideoModalProps } from './VideoModal';
import VideoModal from './VideoModal';

type TrackingProps = {
  eventProps: object;
};

type Props = TrackingProps & VideoModalProps;

const toTrackingOpenHandler = (videoMetadata: object, openHandler?: () => void) => () => {
  openHandler && openHandler();
  trackVideo(VideoEvent.STARTED, videoMetadata);
};

const toTrackingCloseHandler = (
  videoMetadata: object,
  closeHandler?: () => void,
) => () => {
  closeHandler && closeHandler();
  trackVideo(VideoEvent.CLOSED, videoMetadata);
};

const TrackingVideoModal: React.FC<React.PropsWithChildren<Props>> = ({
  eventProps,
  openHandler,
  closeHandler,
  ...props
}) => {
  const trackingOpenHandler = React.useMemo(
    () => toTrackingOpenHandler(eventProps, openHandler),
    [eventProps, openHandler],
  );
  const trackingCloseHandler = React.useMemo(
    () => toTrackingCloseHandler(eventProps, closeHandler),
    [eventProps, closeHandler],
  );
  return (
    <VideoModal
      {...props}
      openHandler={trackingOpenHandler}
      closeHandler={trackingCloseHandler}
    />
  );
};

const mapStateToProps = (
  state: UserSelectorState,
  { eventProps }: Props,
): TrackingProps => {
  const userTrackingProps: object = pickAll(
    ['isLoggedIn', 'hasDeviceSubscription', 'hasDigitalSubscription'],
    getUserTrackingProperties(state),
  );
  return { eventProps: { ...userTrackingProps, ...eventProps } };
};

export default connect(mapStateToProps)(TrackingVideoModal);
